
interface SidebarNavItem {
  link: string;
  section: string;
  icon: string;
  text: string;
  match?: ((pathname: string) => boolean) | RegExp;
}

const sidebarNav: SidebarNavItem[] = [
  {
    link: "/events/all",
    section: "all-events",
    icon: "mdi:calendar-multiselect",
    text: "sidebar.allEventsList",
  },
  {
    link: "/analytics/events",
    section: "analytics",
    icon: "mdi:chart-line",
    text: "sidebar.eventAnalytics",
    match: (pathname: string) => /\/events\/[^/]+\/analytics\/dashboard/.test(pathname) || pathname === "/analytics/events",
  },
  {
    link: "/tickets/lookup",
    section: "tickets",
    icon: "mdi:ticket-confirmation",
    text: "sidebar.ticketLookup",
  }
];

export default sidebarNav;
